import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { CustomNotificationContextProviderProps as Props } from './CustomNotificationContext';
import { removeNotificationFromQueue } from '../redux/actionCreators';
import { getNotificationQueue } from '../redux/selectors';

export type StateProps = Pick<Props, 'notifications'>;
export type DispatchProps = Pick<Props, 'removeNotification'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (state, { queueName }) => ({
  notifications: getNotificationQueue(state, queueName),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  removeNotification: removeNotificationFromQueue,
};

export default connect(mapStateToProps, mapDispatchToProps);
